import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import {
    EValidityStatus,
    fillPaymentSum,
    setCardPaymentSum,
} from '~/src/features/payments-abn/store/actionCreators';
import {
    setPaymentSum,
    validatePaymentSum,
} from '~/src/features/payments-abn/store/actions';
import { TState } from '~/src/store';

import { getInputSumErrorMessage } from './helpers/getInputSumErrorMessage';

import { InputWithRubleSymbol } from './styled';

const sumRegExp = /^(0|[1-9]\d*)(\.\d{0,2})?$/;

/**
 * Форма ввода суммы оплаты
 */
export const PaymentSumInput = (): JSX.Element => {
    const dispatch = useDispatch();

    const { paymentSum, paymentSumValidity } = useSelector((state: TState) => state.payment.paymentData);

    const [bufferSumValue, setBufferSumValue] = useState('');

    useEffect(() => {
        setBufferSumValue(`${paymentSum}`);
    }, [paymentSum]);

    useEffect(() => {
        dispatch(setCardPaymentSum(paymentSum));
    }, [dispatch, paymentSum]);

    const dispatchValue = (value: number) => {
        dispatch(setPaymentSum(value));
        dispatch(validatePaymentSum());
    };

    const onFocusSumHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        if (event.target.value === '0') {
            setBufferSumValue('');
        }

        dispatch(validatePaymentSum({
            isValid: EValidityStatus.IS_VALID,
        }));
    };

    const onChangeSumHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;

        if (!value) {
            setBufferSumValue('');
            dispatchValue(0);
        } else if (sumRegExp.test(value)) {
            setBufferSumValue(value);
            dispatchValue(+value);
        }
    };

    const onBlurSumHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        if (!event.target.value) {
            setBufferSumValue('0');
            dispatch(fillPaymentSum(0));
        }
    };

    const inpuSumErrorMessage = getInputSumErrorMessage(paymentSumValidity);

    return (
        <FullWidthListContainer $size={4} $direction='column'>
            <Paragraph4 $smaller={true} $color={COLORS.TextSecondary}>Сумма пополнения</Paragraph4>
            <InputWithRubleSymbol
                maxLength={'9'}
                value={+bufferSumValue === 0 ? '' : bufferSumValue}
                onFocus={onFocusSumHandler}
                onChange={onChangeSumHandler}
                onBlur={onBlurSumHandler}
                isNotValid={paymentSumValidity.isValid !== EValidityStatus.IS_VALID}
                errorMessage={inpuSumErrorMessage}
                required
            />
        </FullWidthListContainer>
    );
};
